import {ForgotPasswordValidateToken} from 'domain/usecases';
import {RemoteForgotPasswordValidateToken} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from '../../endpoints';

export const makeForgotPasswordValidateToken = (): ForgotPasswordValidateToken =>
	new RemoteForgotPasswordValidateToken(
		makeBFFApiUrl(EntryFlowEndPoints.forgotValidateToken),
		makeAuthorizeHttpClientDecorator(),
	);
